export enum QuoteStatusTypes{
    OPEN = 1,
    ACCEPTED = 2,
    REJECTED = 3,
    CANCELLED = 4,
    DELETED = 5,
    ON_HOLD = 6,
    IN_DISCUSSION = 7,
    ESTIMATE = 8,
    IN_PREVIEW = 9,
}